const dev = {
  API_ENDPOINT_URL: "https://devback.ekrelli.com/api",
  ENDPOINT_URL: "https://dev.ekrelli.com",
  BACKEND_BASE_URL: "https://devback.ekrelli.com",
  NEXT_PUBLIC_REACT_APP_GOOGLE_MAP_API_KEY:
    "AIzaSyAydEQyWbqWvvVA6udvLUW9uyEh2caiPcw",
};

const prod = {
  API_ENDPOINT_URL: "https://backend.ekrelli.com/api",
  ENDPOINT_URL: "https://ekrelli.com",
  BACKEND_BASE_URL: "https://backend.ekrelli.com",
  NEXT_PUBLIC_REACT_APP_GOOGLE_MAP_API_KEY:
    "AIzaSyAydEQyWbqWvvVA6udvLUW9uyEh2caiPcw",
};

const test = {
  API_ENDPOINT_URL: "/api",
  ENDPOINT_URL: "/",
  BACKEND_BASE_URL: "/",
  NEXT_PUBLIC_REACT_APP_GOOGLE_MAP_API_KEY:
    "AIzaSyAydEQyWbqWvvVA6udvLUW9uyEh2caiPcw",
};

const getEnv = () => {
  switch (process.env.REACT_APP_STAGE) {
    case "development":
      return dev;
    case "production":
      return prod;
    case "test":
      return test;
    default:
      return dev;
  }
};

export const env = getEnv();
